import { ReviewsModalBodyComponent } from './../../search-location/reviews-modal-body/reviews-modal-body.component';
import { SearchService } from './../../../services/search.service';
import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { BookingService } from 'src/app/services/booking.service';
import { faArrowLeft, faBriefcase,faGasPump,faUser,faMapMarkerAlt,faCar,faKey, faTags,faDollarSign,faRoad,faBatteryHalf,faBan } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogConfig} from "@angular/material/dialog";
import { IconService } from './../../../services/icon.service';

@Component({
  selector: 'view-booked-car',
  templateUrl: './view-booked-car.component.html',
  styleUrls: ['./view-booked-car.component.css']
})
export class ViewBookedCarComponent implements OnInit {

  MakeModelYearSearch=false;
  vehicleSearch=true;
  classSearch=false;
  bookedVehicle;
  currency;

  faGasPump = faGasPump;
  faUser = faUser;
  faMapMarkerAlt = faMapMarkerAlt;
  faCar = faCar;
  faArrowLeft =faArrowLeft
  faKey = faKey;
  faTags = faTags;
  faDollarSign = faDollarSign;
  faRoad = faRoad;
  faBatteryHalf = faBatteryHalf;
  faBan = faBan;

  constructor(
    private searchService: SearchService,
    private bookingService:BookingService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private iconService:IconService,) {

    this.currency = searchService.getCurrency();

    // this.matIconRegistry.addSvgIcon(
    //   "car-gear",
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.carGearIcon)
    // );
    // this.matIconRegistry.addSvgIcon(
    //   "car-door",
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.carDoorIcon)
    // );
    this.matIconRegistry.addSvgIcon(
      "timeIcon",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.timeIcon)
    );
    this.matIconRegistry.addSvgIcon(
      "supplierMapIcon",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.supplierMapIcon)
    );
  }
  openDialog() {
    const dialogConfig = new MatDialogConfig();
    this.dialog.open(ReviewsModalBodyComponent, dialogConfig);
  }


  ngOnInit() {
  }

}
